module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Tabs is a Nessie Tab&#39;s group.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Tabs&gt;\n    &lt;Tab label=&quot;Dashboard&quot;&gt;\n        &lt;div&gt;Some content&lt;/div&gt;\n    &lt;/Tab&gt;\n    &lt;Tab label=&quot;Reporting&quot;&gt;\n        &lt;Button&gt;A cool button&lt;/Button&gt;\n    &lt;/Tab&gt;\n&lt;/Tabs&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Tabs/README.md
// module id = 398
// module chunks = 0